import { render } from "./MatchSessionTabs.vue?vue&type=template&id=6decbc00&scoped=true"
import script from "./MatchSessionTabs.vue?vue&type=script&lang=js"
export * from "./MatchSessionTabs.vue?vue&type=script&lang=js"

import "./MatchSessionTabs.vue?vue&type=style&index=0&id=6decbc00&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6decbc00"]])

export default __exports__